import React from 'react';
import {
  Map as MapIcon,
  EditLocationAlt as EditLocationAltIcon,
  CompareArrows as CompareArrowsIcon,
  CleaningServices as CleaningServicesIcon,
  MyLocation as MyLocationIcon,
  Timeline as TimelineIcon,
  Route as RouteIcon,
  TableChart as TableChartIcon,
  SatelliteAlt as SatelliteAltIcon,
  Construction as ConstructionIcon
} from '@mui/icons-material';

import ToolAppLayout from '../../layouts/ToolAppLayout';


import GeoJsonViewer from './GeoJsonViewer';
import GeoJsonEditor from './GeoJsonEditor';
import RouteMatcherVisualizer from './RouteMatcherVisualizer';
import GpsDriftCleaner from './GpsDriftCleaner';
import CoordinateConverter from './CoordinateConverter';
import TelemetryTripAnalyzer from './TelemetryTripAnalyzer';
import CsvToGeoJson from './CsvToGeoJson';
import TelematicsApp from './TelematicsApp';
import GeoJsonToolkit from './GeoJsonToolkit';
import Graphify from './Graphify';
import RouteDrawer from './RouteDrawer';

const toolCategories = [
  {
    name: 'Map & Geometry',
    tools: [
      { name: 'Viewer', description: 'View GeoJSON, GPX, and KML files on a map', path: 'geojson-viewer', icon: <MapIcon fontSize="small" />, component: GeoJsonViewer },
      { name: 'Editor', description: 'Create and edit GeoJSON geometries interactively', path: 'geojson-editor', icon: <EditLocationAltIcon fontSize="small" />, component: GeoJsonEditor },
      { name: 'Route Drawer', description: 'Draw custom routes along roads', path: 'route-drawer', icon: <RouteIcon fontSize="small" />, component: RouteDrawer },
    ]
  },
  {
    name: 'Data Conversion',
    tools: [
      { name: 'Coord Converter', description: 'Convert coordinates between formats', path: 'coordinate-converter', icon: <MyLocationIcon fontSize="small" />, component: CoordinateConverter },
      { name: 'CSV → GeoJSON', description: 'Convert CSV data to spatial GeoJSON', path: 'csv-to-geojson', icon: <TableChartIcon fontSize="small" />, component: CsvToGeoJson },
      { name: 'Toolkit', description: 'Various GeoJSON utility operations', path: 'geojson-toolkit', icon: <ConstructionIcon fontSize="small" />, component: GeoJsonToolkit },
    ]
  },
  {
    name: 'GPS & Routing',
    tools: [
      { name: 'Route Matcher', description: 'Match raw GPS traces to road networks', path: 'route-matcher', icon: <CompareArrowsIcon fontSize="small" />, component: RouteMatcherVisualizer },
      { name: 'Drift Cleaner', description: 'Clean up noisy GPS points', path: 'gps-drift-cleaner', icon: <CleaningServicesIcon fontSize="small" />, component: GpsDriftCleaner },
    ]
  },
  {
    name: 'Telemetry & Analytics',
    tools: [
      { name: 'Trip Analyzer', description: 'Analyze telematics trips and metrics', path: 'trip-analyzer', icon: <TimelineIcon fontSize="small" />, component: TelemetryTripAnalyzer },
      { name: 'Graphify', description: 'Visualize telemetry time-series data', path: 'graphify', icon: <TimelineIcon fontSize="small" />, component: Graphify },
      { name: 'Telematics Hub', description: 'Main telematics overview dashboard', path: 'telematics/*', icon: <SatelliteAltIcon fontSize="small" />, component: TelematicsApp },
    ]
  }
];

function SpatialToolsApp() {
  return (
    <ToolAppLayout
      title="Spatial Tools"
      description="Select a tool below to begin visualizing, converting, or analyzing spatial data."
      toolCategories={toolCategories}
      basePath="/spatial-tools-app"
    />
  );
}

export default SpatialToolsApp;
